export function isPwa(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone === true;
}

export function resizeWindow(width: number, height: number) {
  const extraWidth = window.outerWidth - window.innerWidth;
  const extraHeight = window.outerHeight - window.innerHeight;

  window.resizeTo(width + extraWidth, height + extraHeight);
}
